import type { FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";
import { Flex, Text, type ClassNameProp } from "@huub-web/ui";

import type { FAQItemRecord } from "../../types";

import { containerStyle } from "./FAQItem.css";

export type FAQItemProps = ClassNameProp & {
  record: FAQItemRecord;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * FAQItem component represents an individual FAQ item with question and answer.
 */
export const FAQItem: FC<FAQItemProps> = ({ className, record, ref }) => (
  <Flex
    ref={ref}
    className={mergeClasses(containerStyle, className)}
    direction="column"
    gap="l"
  >
    <Text as="h2" variant="header">
      {record.title}
    </Text>
    <Text markdown variant="bodyL">
      {record.summary}
    </Text>
    <Text markdown>{record.content}</Text>
  </Flex>
);
